import script from "./HomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePage.vue?vue&type=script&setup=true&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=0047a5f8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0047a5f8"]])

export default __exports__